export default __webpack_public_path__ + "static/media/entenda_d_livre.d8dc651a.jpg";